import {
  createAsyncStateReducer,
  Status,
  type AsyncState,
} from '@essent/common';
import {
  getTariffsActions,
  type GetTariffsPayload,
  type Tariffs,
} from '@essent/extension-offer';
import { combineReducers, createReducer, on, type Action } from '@ngrx/store';
import type { Offer } from '@innogy/become-a-customer/shared/interfaces';

import {
  clearCurrentContract,
  mapCurrentContract,
} from './current-contract.actions';
import { mapTariffsToContract } from './current-contract.mapper';

// The CurrentContract interface is backwards compatible with Offer so it can be used in offer cards and AOM modals
export type CurrentContract = Offer & {
  isCurrentContract: true;
  endDate?: string;
  renewableDate?: string;
};

export interface CurrentContractState {
  tariffs: AsyncState<Tariffs>;
  contract: CurrentContract | null;
}

const initialState: CurrentContractState = {
  tariffs: { status: Status.IDLE },
  contract: null,
};

const _reducer = combineReducers(
  {
    tariffs: createAsyncStateReducer<GetTariffsPayload, Tariffs>(
      getTariffsActions
    ),
    contract: createReducer(
      initialState.contract,
      on(mapCurrentContract, (_, { tariffs, contracts }) => {
        try {
          return mapTariffsToContract(tariffs, contracts);
        } catch {
          return null;
        }
      }),
      on(clearCurrentContract, () => initialState.contract)
    ),
  },
  initialState
);

export function currentContractReducer(
  state: CurrentContractState | undefined,
  action: Action
): CurrentContractState {
  return _reducer(state, action);
}
